import React from "react";

import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import LearnTextEmbed from "../LearnPanelComponents/LearnCopy/LearnTextEmbed";

type ScenarioSelectorProps = {
  currentScenario: string;
  scenarioOptions: string[]; //these will be replaced
  onChange: (newOption: string) => void;
  color?: "primary" | "secondary" | "info" | "success" | "warning" | "error" | undefined;
  helperText?: string;
};

function ScenarioSelector(props: ScenarioSelectorProps) {
  return (
    <FormControl sx={{ flexGrow: 1 }}>
      <TextField
        select
        fullWidth
        label="Add a Forecast"
        value={props.currentScenario}
        color={props.color}
        variant="standard"
        onChange={(newValue) => props.onChange(newValue.target.value)}
        FormHelperTextProps={{ component: "div" }}
        helperText={props.helperText ? <LearnTextEmbed content={props.helperText} /> : undefined}
      >
        {props.scenarioOptions.map((option) => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </TextField>
    </FormControl>
  );
}

export default ScenarioSelector;
